import { render, staticRenderFns } from "./xlsDropdown.vue?vue&type=template&id=58157586&"
import script from "./xlsDropdown.vue?vue&type=script&lang=js&"
export * from "./xlsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports